import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Header from './components/Header';
import TokenInfo from './components/TokenInfo';
import CanvasEditor from './components/CanvasEditor';
import ShareSection from './components/ShareSection';
import Footer from './components/Footer';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #0f0f0f 50%, #0a0a0a 100%);
  position: relative;
  overflow-x: hidden;
`;

const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(34, 197, 94, 0.12) 0%, transparent 60%),
    radial-gradient(circle at 80% 20%, rgba(34, 197, 94, 0.08) 0%, transparent 60%),
    radial-gradient(circle at 40% 80%, rgba(34, 197, 94, 0.1) 0%, transparent 60%),
    radial-gradient(circle at 60% 40%, rgba(34, 197, 94, 0.06) 0%, transparent 50%);
  pointer-events: none;
  will-change: auto;
`;

const MainContent = styled(motion.div)`
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
  z-index: 1;
  will-change: auto;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const FloatingElements = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
`;

const FloatingElement = styled.div`
  position: absolute;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  background: radial-gradient(circle, ${props => props.$color} 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0.15;
  top: ${props => props.$top}%;
  left: ${props => props.$left}%;
  filter: blur(1px);
  box-shadow: 0 0 ${props => props.$size * 0.5}px ${props => props.$color}40;
  will-change: auto;
  transform: translateZ(0);
`;

function App() {
  return (
    <AppContainer>
      <BackgroundPattern />
      <FloatingElements>
        <FloatingElement $size={60} $color="#22c55e" $top={10} $left={10} $duration={6} />
        <FloatingElement $size={40} $color="#16a34a" $top={20} $left={80} $duration={8} />
        <FloatingElement $size={80} $color="#22c55e" $top={60} $left={5} $duration={10} />
        <FloatingElement $size={50} $color="#16a34a" $top={80} $left={90} $duration={7} />
        <FloatingElement $size={30} $color="#22c55e" $top={30} $left={70} $duration={9} />
      </FloatingElements>
      <MainContent
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Header />
        <TokenInfo />
        <ContentGrid>
          <CanvasEditor />
          <ShareSection />
        </ContentGrid>
      </MainContent>
      {/* <Footer /> */}
    </AppContainer>
  );
}

export default App;
